import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "managing-brand-assets"
    }}>{`Managing brand assets`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Marketing teams need to update documents regularly with new product information, messaging, and branding. It’s challenging to make updates broadly when rebranding occurs or when certain text strings need to be updated.`}</p>
    <p>{`Adobe Acrobat Services allows organizations to:`}</p>
    <ul>
      <li parentName="ul">{`Create searchable PDF documents using OCR`}</li>
      <li parentName="ul">{`Preview PDFs in a UI using PDF Embed API`}</li>
      <li parentName="ul">{`Merge Microsoft Word templates with dynamic data fields that can be updated with new branding and messaging`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation"
        }}>{`Adobe Document Generation API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A marketing team struggles to manage and update their many documents due to a recent branding change. They need an easy way to maintain internal- and external-facing marketing materials, search for terms, display documents, and edit dynamic fields to refresh and republish content.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <p>{`In this solution, see how your organization can utilize this process:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Use PDF Services API Create PDF, OCR, and Compress services to streamline and standardize documents as PDFs`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Adobe Document Generation API can be used to create templates for branded documents that need to be updated frequently. Dynamic data is pulled from various systems to inject into the templates and generate PDF or Word documents with updated images and text.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The search engine provides links to documents that use PDF Embed API to provide a consistent visual experience to the user`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      